import { render } from "./Sawmill.vue?vue&type=template&id=239ce541"
import script from "./Sawmill.vue?vue&type=script&lang=js"
export * from "./Sawmill.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/buildings/Sawmill.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "239ce541"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('239ce541', __exports__)) {
    api.reload('239ce541', __exports__)
  }
  
  module.hot.accept("./Sawmill.vue?vue&type=template&id=239ce541", () => {
    api.rerender('239ce541', render)
  })

}


export default __exports__